import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type ToNgPromiseFilter<T> = (input: Promise<T>) => ng.IPromise<T>;

interface IToNgPromise<T> {
  transform: ToNgPromiseFilter<T>;
}

/**
 * Filter that wraps native promise to $q from
 * @param {Promise<any>} input native promise
 * @return {ng.IPromise} angular's promise
 */
@Pipe({ name: 'toNgPromise' })
export class ToNgPromisePipe implements PipeTransform, IToNgPromise<any> {
  constructor(private $q: ng.IQService) {
    'ngInject';
  }

  public transform(input: Promise<any>): ng.IPromise<any> {
    if (angular.isObject(input) && angular.isFunction(input.then)) {
      const deferred = this.$q.defer();

      input.then(
        (value) => {
          deferred.resolve(value);
        },
        (error) => {
          deferred.reject(error);
        },
      );

      return deferred.promise;
    }

    return input;
  }
}
